import React from "react";

function DocsSVGnew(classes: any) {
  return (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3125 5.4H14.4375L9.375 0.54V4.5C9.375 5.04 9.75 5.4 10.3125 5.4ZM10.3125 7.2C8.71875 7.2 7.5 6.03 7.5 4.5V0H2.8125C1.21875 0 0 1.17 0 2.7V15.3C0 16.83 1.21875 18 2.8125 18H12.1875C13.7812 18 15 16.83 15 15.3V7.2H10.3125ZM4.6875 5.4H5.625C6.1875 5.4 6.5625 5.76 6.5625 6.3C6.5625 6.84 6.1875 7.2 5.625 7.2H4.6875C4.125 7.2 3.75 6.84 3.75 6.3C3.75 5.76 4.125 5.4 4.6875 5.4ZM10.3125 14.4H4.6875C4.125 14.4 3.75 14.04 3.75 13.5C3.75 12.96 4.125 12.6 4.6875 12.6H10.3125C10.875 12.6 11.25 12.96 11.25 13.5C11.25 14.04 10.875 14.4 10.3125 14.4ZM10.3125 10.8H4.6875C4.125 10.8 3.75 10.44 3.75 9.9C3.75 9.36 4.125 9 4.6875 9H10.3125C10.875 9 11.25 9.36 11.25 9.9C11.25 10.44 10.875 10.8 10.3125 10.8Z"
        fill="#8E8E8E"
      />
    </svg>
  );
}

export default DocsSVGnew;
